export default __webpack_public_path__ + "static/media/forbidden_curse_scroll.7afb8960.png";